import PropTypes from "prop-types";

import styles from "./NewPill.scss";

const NewPill = ({ text }) => {
  return <span className={styles.container}>{text}</span>;
};

NewPill.propTypes = {
  text: PropTypes.string.isRequired,
};

export default NewPill;
